<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="deptPublication?.deptPub"

[label]="step1.getdeptpub"
[type]="'select'"
[typeSelect]="optionsSelectType"
[optionsWithCode]="optionsSelect"
[rule]="'required|pattern_5'"
[errorMessage]="{'required' : 'ctr_106'}"
[name]="getUid()+'_SepAtt_deptPub'">
</app-form-input>
<!-- PRB0052636: pattern_5: mettre la liste dans un groupe de sous-expression en l'entourant de () dans pattern.json -->
<app-form-input  [label]="'Autre(s) département(s)'"
	[name]="getUid() + '_SepAtt_rappel'" [parentForm]="parentForm" [disabled]="disabled"
	[type]="'chips'" [rule]="'pattern_5'" [value]="deptPublication?.rappel"
	[autoCompleteType]="'RAPPEL'" [autoCompleteTypeIndex]="0" [infoBulle]="infobulle">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg2" [id]="getStepId() + rg2"></app-form-input-error>
{{ step1.getspan4 | translate }}
